<template>
<div>

   <!--<Section background="white"  class="image-bg"-->
   <!--         :style="{'background-image': `url(${require('../../assets/images/content/pexels-photomix-company-106341.jpg')})`}"-->

   <!--&gt;-->

   <!--   <nav-bar dark></nav-bar>-->
   <!--   &lt;!&ndash;      <div class=" main-heading heading-line pt-1">&ndash;&gt;-->
   <!--   &lt;!&ndash;      </div>&ndash;&gt;-->

   <!--   &lt;!&ndash;      <div class=" main-heading heading-line" style=" width: 100%;" >&ndash;&gt;-->
   <!--   &lt;!&ndash;      </div>&ndash;&gt;-->

   <!--   <div class=" main-heading" style=" width: 100%;" >-->
   <!--      <v-container fluid class="heading-line">-->
   <!--         <div class="center display-2">Links of Interest</div>-->
   <!--      </v-container>-->
   <!--   </div>-->


   <!--</Section>-->



   <v-container>

      <p style="margin-bottom:10px"></p>

      <p><a href ="http://www.3abn.org">3ABN</a></p>
      <p><a href ="http://www.amazingdiscoveries.org">Amazing Discoveries</a></p>
      <p><a href ="http://www.drmcdougall.com">Dr. McDougall</a></p>
      <p><a href ="http://www.sunriseministry.org">Sunrise Ministry</a></p>
      <p><a href ="http://www.seedsofdeception.com">Seeds of Deception</a></p>
      <p><a href ="http://www.amazingfacts.org">Amazing Facts</a></p>
      <p><a href ="http://www.illustramedia.com">Illustra Media</a></p>
      <p><a href ="http://www.leeStrobel.com">Lee Strobel</a></p>
      <p><a href ="http://www.modernmanna.org">Modern Manna</a></p>
      <p><a href ="http://www.coldwatermedia.com">Coldwater Media</a></p>
      <p><a href ="http://www.secretsunsealed.org/">Secrets Unsealed</a></p>
      <p><a href ="http://www.answersinggenesis.org">Answersing Genesis </a></p>
      <p><a href ="http://www.asiministries.org">ASI Ministries</a></p>
      <p><a href ="http://www.libertymagazine.org">Liberty Magazine</a></p>
      <p><a href ="http://theperfectstormiscoming.org/">The Perfect Storm is Coming</a></p>
   </v-container>




</div>
</template>

<script>

import navBar from '@/components/navBar.vue'
import Section from "@/components/Section";


export default {
name: "Links",
   components: {navBar, Section, },
}
</script>

<style scoped>

.main-heading{
   height: 200px;
   display: flex;
   align-items: center;
   justify-content: center;

}


.heading-line{
   text-align: center;
   color:#ffffff;
   /*background-color:rgba(43,43,43,0.4);*/
   width: 100%;

}
</style>
